class ClickWorker {
    constructor(menu) {

        this._menu = menu;
        this._timeout = +menu.options.timeoutForHide;

        this._onTriggerClick = this._onTriggerClick.bind(this);
        this._onTriggerEnter = this._onTriggerEnter.bind(this);
        this._onTriggerLeave = this._onTriggerLeave.bind(this);
        this._onLeave = this._onLeave.bind(this);

        var triggerEl = menu.getTriggerEl(), el = menu.getEl();

        triggerEl.addEventListener('click', this._onTriggerClick);
        triggerEl.addEventListener('mouseleave', this._onTriggerLeave);
        triggerEl.addEventListener('mouseenter', this._onTriggerEnter);

        el.addEventListener('mouseleave', this._onTriggerLeave);
        el.addEventListener('mouseenter', this._onTriggerEnter);

        if (!menu.options.usePropagate) {
            this._onMenuClickHandler = this._onMenuClick.bind(this);
            el.addEventListener('click', this._onMenuClickHandler);
        }
    }

    _onTriggerEnter() {
        this._clearLeaveTimeout();
    }

    _onTriggerLeave() {
        this._leaveTimeout = setTimeout(this._onLeave, this._timeout);
    }

    _clearLeaveTimeout() {
        if (this._leaveTimeout) {
            clearTimeout(this._leaveTimeout);
            this._leaveTimeout = null;
        }
    }

    _onLeave() {
        this._clearLeaveTimeout();
        this._menu.hide();
    }

    _onTriggerClick(e) {
        e.preventDefault();
        this._menu.toogle();
    }

    _onMenuClick(e) {
        e.stopPropagation();
    }

    destroy() {

        var menu = this._menu, triggerEl = menu.getTriggerEl(), el = menu.getEl();

        triggerEl.removeEventListener('click', this._onTriggerClick);
        triggerEl.removeEventListener('mouseleave', this._onTriggerLeave);
        triggerEl.removeEventListener('mouseenter', this._onTriggerEnter);

        el.removeEventListener('mouseleave', this._onTriggerLeave);
        el.removeEventListener('mouseenter', this._onTriggerEnter);

        this._clearLeaveTimeout();

        if (this._onMenuClickHandler) {
            el.removeEventListener('click', this._onMenuClickHandler);
        }

        OK.util.clean(this);

    }
}


export default ClickWorker;
